// This is the close button component for the Mux modal player

import { html } from "htm/preact";
import { useRef, useEffect, useState } from "preact/hooks";

export default function MuxModal() {
  // Ref to the close (X) button inside the modal
  const buttonRef = useRef(null);

  // Tracks whether the modal is currently open
  const [open, setOpen] = useState(false);

  // Ensures the query-param auto-open only fires once on mount
  const hasAutoOpened = useRef(false);


  useEffect(() => {
    const closeBtn = buttonRef.current;
    if (!closeBtn) return;

    // Traverse DOM to find related elements
    const parentDiv = closeBtn.parentElement.parentElement;
    const globalDiv = parentDiv.parentElement;  // higher-level container
    const modalBtn = globalDiv.querySelector("[data-modal-button]");
    const videoDiv = parentDiv.querySelector("[data-mux-simple]");

    const closeModalWindow = () => {
      // Pause Mux player before closing the modal (prevents continued play when hidden)
      const media = videoDiv?.querySelector("mux-player")?.media;
      if (media) media.pause();
      
      parentDiv.setAttribute("aria-hidden", "true");
      setOpen(false);
    }

    const openModalWindow = () => {
      parentDiv.setAttribute("aria-hidden", "false");
      setOpen(true);
    }

    // higher-level container
    const handleClickOutside = (event) => {
      if (!videoDiv.contains(event.target) && open) {
        closeModalWindow();
      }
    }

    // Close modal on escape keydown
    const handleEscapeKey = (event) => {
      if (event.key === "Escape" && open) {
        closeModalWindow();
      }
    }

    // Auto-open when ?video_open query parameter is present (runs once on mount)
    if (!hasAutoOpened.current) {
      hasAutoOpened.current = true;
      try {
        const params = new URLSearchParams(window.location.search);
        if (params.has("video_open") && videoDiv?.querySelector("mux-player")) {
          openModalWindow();
        }
      } catch (_) {
        // Malformed URL or missing elements — skip auto-open gracefully
      }
    }

    // Global and local event listeners
    document.addEventListener("click", handleClickOutside);
    document.addEventListener("keydown", handleEscapeKey);
    closeBtn.addEventListener("click", closeModalWindow);
    modalBtn.addEventListener("click", openModalWindow);

    // Cleanup listeners on unmount or state change
    return () => {
      document.removeEventListener("click", handleClickOutside);
      document.removeEventListener("keydown", handleEscapeKey);
      closeBtn.removeEventListener("click", closeModalWindow);
      modalBtn.removeEventListener("click", openModalWindow);
    }
  }, [open])


  return html`
    <button ref=${buttonRef} class="transition-colors cursor-pointer p-2 rounded-full text-white hover:bg-white/5">
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1" stroke="currentColor" class="size-6">
        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
      </svg>
    </button>
  `
}